import { ComparableEnrollment, Enrollment } from './index';

class RosterEnrollment extends ComparableEnrollment {
  constructor(enrollment: Enrollment, public readonly included: boolean) {
    super(enrollment);
  }
}

export default RosterEnrollment;
